import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: "1",
};
const soundSlice = createSlice({
  name: "sound",
  initialState,
  reducers: {
    setId: (state, action) => {
      state.value = action.payload;
    },
  },
});
export const { setId } = soundSlice.actions;
export default soundSlice.reducer;
